<template>
  <div class="property-dialog">
<!--    开始-->
    <StartProperty v-if="nodeData.type === 'start'"
                   :nodeData="nodeData"
                   :lf="lf" />
<!--    用户-->
    <UserProperty v-else-if="nodeData.type === 'user'"
          :nodeData="nodeData"
          :lf="lf" />
<!--    条件-->
    <ExclusiveGatewayProperty v-else-if="nodeData.type === 'exclusiveGateway'"
                      :nodeData="nodeData"
                      :lf="lf" />
<!--    线-->
    <PolylineProperty v-else-if="nodeData.type === 'polyline'"
              :nodeData="nodeData"
              :lf="lf" />
<!--    服务-->
    <ServiceProperty v-else-if="nodeData.type === 'setting'"
                     :nodeData="nodeData"
                     :lf="lf" />
<!--    合流-->
    <ConfluenceProperty v-else-if="nodeData.type === 'confluence'"
                        :nodeData="nodeData"
                        :lf="lf" />
<!--    分流-->
    <DistributaryProperty v-else-if="nodeData.type === 'distributary'"
                          :nodeData="nodeData"
                          :lf="lf" />
<!--    结束-->
    <EndProperty v-else-if="nodeData.type === 'end'"
                 :nodeData="nodeData"
                 :lf="lf" />
    <CommonProperty
      v-else
      :nodeData="nodeData"
      :lf="lf"
      @onClose="handleClose"/>
  </div>
</template>
<script>
import CommonProperty from './CommonProperty'
import UserProperty from './UserProperty'
import StartProperty from "./StartProperty";
import ExclusiveGatewayProperty from "./ExclusiveGatewayProperty";
import PolylineProperty from "./PolylineProperty";
import ServiceProperty from "./ServiceProperty";
import ConfluenceProperty from "./ConfluenceProperty";
import DistributaryProperty from "./DistributaryProperty";
import EndProperty from "./EndProperty";

export default {
  name: 'PropertyDialog',
  components: {
    EndProperty,
    DistributaryProperty,
    ConfluenceProperty,
    ServiceProperty,
    PolylineProperty,
    ExclusiveGatewayProperty,
    StartProperty,
    CommonProperty,
    UserProperty
  },
  props: {
    nodeData: Object,
    lf: Object
  },
  data () {
    return {}
  },
  methods: {
    handleClose () {
      this.$emit('setPropertiesFinish')
    }
  }
}
</script>
<style>
.property-dialog{
  /*padding: 20px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/PropertyDialog.vue